<script setup>
import { computed } from 'vue';


const props = defineProps({
    score: {
        type: String,
        required: true,
    },
});

const sustainabilityLabel = computed(() => {
    if (props.score >= 8) {
        return 'A';
    } if (props.score >= 6 && props.score < 8) {
        return 'B';
    }
    return 'C';
});
</script>
<template>
    <span class="product-green-score" :class="`green-score-label-${sustainabilityLabel}`">
        Groenscore
        <span class="arrow-right" :class="`score-${sustainabilityLabel}`">{{ sustainabilityLabel }}</span>
    </span>
</template>

<style lang="scss" scoped>
@use 'assets/scss/all' as *;

.product-green-score {
    display: inline-flex;
    align-items: center;
    gap: 8px;

    &.green-score-b {
        background-color: #f7e9d3;
        color: #bd7b0a;

        .green-arrow-right {
            border-left-color: #f7e9d3;
        }
    }

    &.green-score-c {
        color: #838383;
        background-color: #ebebeb;

        .green-arrow-right {
            border-left-color: #ebebeb;
        }
    }

    .arrow-right {
        position: relative;
        width: 20px;
        height: 18px;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        font-weight: 600;
        display: inline-flex;


        &::after {
            content: '';
            width: 0;
            height: 0;
            border-top: 9px solid transparent;
            border-bottom: 9px solid transparent;
            border-left: 9px solid;
            position: absolute;
            right: -9px;
        }

        &.score-A {
            background-color: $green-20;
            color: $green-50;

            &::after {
                border-left: 9px solid $green-20;
            }
        }

        &.score-B {
            background-color: #f7e9d3;
            color: #bd7b0a;

            &::after {
                border-left: 9px solid #f7e9d3;
            }
        }

        &.score-C {
            color: #838383;
            background-color: #ebebeb;

            &::after {
                border-left: 9px solid #ebebeb;
            }
        }
    }
}
</style>